// extracted by mini-css-extract-plugin
export var audioPlayer = "_ti-0";